export default __webpack_public_path__ + "static/media/img_ceo.46f0fc81.png";